// extracted by mini-css-extract-plugin
export default {"steps_custom":"campaigns_steps_custom__pIKeq","impact":"campaigns_impact__aJVE3","confirm_buttons":"campaigns_confirm_buttons__-kEqP"};